import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import hash from 'object-hash';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';
import { AdditionalServicesType } from 'types/UFOTypes';

interface GetAdditionalServicesParams {
  with_service_mspn: boolean;
  fleet_id: string;
  dealer_id: string;
  isMobile: boolean;
  query?: string;
}

const getAdditionalServices: MaestroAPI = { method: 'GET', endpoint: 'getAddlServices/ufo', baseURL };

export function useGetAdditionalServices(payload: GetAdditionalServicesParams | null) {
  return useQuery<{ addlServices: AdditionalServicesType[] } | null>(
    ['get-additional', hash(payload)],
    () => {
      if (payload?.query && payload.query.length < 4) return null;
      if (payload) return maestroApiCall(getAdditionalServices, payload);
      return null;
    },
    {
      cacheTime: 3600,
    },
  );
}
